import { ORGANISATION, resolveOrganisation } from 'src/constants/organisation';

export { resolveOrganisation };

type UnitTerm = {
  singular: string;
  plural: string;
};

const DEFAULT_UNIT_TERM: UnitTerm = {
  singular: 'Unit',
  plural: 'Units',
};

/**
 * Resolves the unit term for an organisation: "Lodge"/"Lodges" for UGLE,
 * "Chapter"/"Chapters" for SGC. Falls back to the generic "Unit"/"Units" when
 * the organisation cannot be determined.
 */
export function resolveUnitTerm(
  organisationId: number | string | null | undefined
): UnitTerm {
  const organisation = resolveOrganisation(organisationId);
  if (!organisation) return DEFAULT_UNIT_TERM;
  return {
    singular: organisation.unitSingular,
    plural: organisation.unitPlural,
  };
}

/**
 * Resolves the organisation name. Returns the short name (e.g. "UGLE") by
 * default, or the full name (e.g. "United Grand Lodge of England") when
 * `full` is true. Returns an empty string when the organisation is unknown.
 */
export function resolveOrganisationName(
  organisationId: number | string | null | undefined,
  full = false
): string {
  const organisation = resolveOrganisation(organisationId);
  if (!organisation) return '';
  return full ? organisation.fullName : organisation.shortName;
}

export function isUGLE(
  organisationId: number | string | null | undefined
): boolean {
  if (organisationId == null) return false;
  return Number(organisationId) === ORGANISATION.UGLE;
}

export function isSGC(
  organisationId: number | string | null | undefined
): boolean {
  if (organisationId == null) return false;
  return Number(organisationId) === ORGANISATION.SGC;
}
